import { LanguageOption } from './types/Contact';

const LANGUAGE_DISPLAY_NAMES: Record<string, string> = {
  en: 'English',
  az: 'Azerbaijani',
  ru: 'Russian',
  nl: 'Dutch',
  tr: 'Turkish',
  english: 'English',
  azerbaijani: 'Azerbaijani',
  azerbaijanian: 'Azerbaijani',
  russian: 'Russian',
  dutch: 'Dutch',
  turkish: 'Turkish',
};

export const languageOptions = [
  { code: 'English', label: 'English' },
  { code: 'Azerbaijani', label: 'Azerbaijani' },
  { code: 'Russian', label: 'Russian' },
  { code: 'Turkish', label: 'Turkish' },
] as const;

export const normalizeLanguageValue = (value?: string): string => {
  const normalized = (value || '').trim().toLowerCase();
  if (normalized === 'english' || normalized === 'en') return 'English';
  if (normalized === 'azerbaijani' || normalized === 'azerbaijanian' || normalized === 'az') return 'Azerbaijani';
  if (normalized === 'russian' || normalized === 'ru') return 'Russian';
  if (normalized === 'turkish' || normalized === 'tr') return 'Turkish';
  return 'English';
};

export const getLanguageDisplayName = (value?: string, options?: LanguageOption[]): string => {
  const trimmed = (value || '').trim();
  if (!trimmed) {
    return '';
  }

  const normalized = trimmed.toLowerCase();
  const metadataMatch = options?.find(option => {
    const code = option.code.trim().toLowerCase();
    const label = option.label.trim().toLowerCase();
    return code === normalized || label === normalized;
  });

  if (metadataMatch) {
    const label = metadataMatch.label.trim();
    const code = metadataMatch.code.trim().toLowerCase();
    if (label && label.toLowerCase() !== code) {
      return label;
    }
  }

  const mapped = LANGUAGE_DISPLAY_NAMES[normalized];
  if (mapped) {
    return mapped;
  }

  const formOption = languageOptions.find(
    option => option.code.toLowerCase() === normalized || option.label.toLowerCase() === normalized,
  );
  if (formOption) {
    return formOption.label;
  }

  return trimmed;
};
